import type { PolicyDecision } from "@t3tools/contracts";

import type { I18nKey } from "./i18n";

export function describePolicyControl(decision: PolicyDecision | undefined) {
  if (decision?.allowed) return { visible: true, disabled: false, reason: null };
  if (decision === undefined) return { visible: false, disabled: true, reason: null };

  let reason: I18nKey;
  switch (decision.cause) {
    case "offline":
      reason = "chat/noInternetConnection_wsrjkq";
      break;
    case "plan":
      reason = "chat/unavailableOnYourPlan_otmrls";
      break;
  }
  return { visible: decision.cause !== "plan", disabled: true, reason };
}
